import { render, staticRenderFns } from "./pennants.vue?vue&type=template&id=28807e72&scoped=true&"
import script from "./pennants.vue?vue&type=script&lang=js&"
export * from "./pennants.vue?vue&type=script&lang=js&"
import style0 from "./pennants.vue?vue&type=style&index=0&id=28807e72&lang=scss&scoped=true&"
import style1 from "./pennants.vue?vue&type=style&index=1&id=28807e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28807e72",
  null
  
)

export default component.exports